import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { CONFLICTING_CONTACT_EMAIL_VALUE } from '../PropertyValidationErrorCodes';
// @ts-expect-error Not Typed yet
import KnowledgeBaseButton from 'ui-addon-i18n/components/KnowledgeBaseButton';
import { isContactEmail } from 'customer-data-objects/property/PropertyIdentifier';
import { denormalizeTypeId } from 'customer-data-objects/constants/ObjectTypeIds';
import { CONFLICTING_UNIQUE_VALUE, CONTAINS_INVALID_CHARACTERS, EMAIL_GDPR_DELETED, INVALID_ALPHA, INVALID_ALPHANUMERIC, INVALID_DECIMAL_PRECISION, INVALID_EMAIL, INVALID_END_DATE, INVALID_FORMAT_CAPITALIZATION, INVALID_FORMAT_EMAIL, INVALID_FORMAT_LOWER, INVALID_FORMAT_UPPER, INVALID_NUMERIC, INVALID_START_DATE, INVALID_BEFORE_DURATION, INVALID_AFTER_DURATION, INVALID_DAYS_OF_WEEK, MAX_LENGTH, MAX_NUMBER, MIN_LENGTH, MIN_NUMBER, INVALID_START_DATETIME, INVALID_END_DATETIME, INVALID_BEFORE_DATETIME_DURATION, INVALID_AFTER_DATETIME_DURATION } from './ValidationResults';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getErrorCode = (validatePropertyApiResponse, property, objectTypeId) => {
  if (validatePropertyApiResponse.error === CONFLICTING_UNIQUE_VALUE) {
    // Contact emails need a special error code so we can link to a knowledge
    // base doc describing why they must have unique values
    if (isContactEmail(property, denormalizeTypeId(objectTypeId))) {
      return CONFLICTING_CONTACT_EMAIL_VALUE;
    }
  }
  return validatePropertyApiResponse.error;
};

// The API returns pre-translated error messages only for a subset of
// errors. This is the allowlist of error codes which are known to have BE
// translations; it is safe to show the raw error `message` from the API for an
// error with one of these codes.
const shouldShowApiErrorMessage = errorCode => {
  switch (errorCode) {
    // standard validation error codes that have BE translations
    case CONFLICTING_UNIQUE_VALUE:
    case INVALID_EMAIL:
    case EMAIL_GDPR_DELETED:
      return true;
    // custom validation error codes (all custom validation error codes have BE translations)
    case INVALID_FORMAT_CAPITALIZATION:
    case INVALID_FORMAT_UPPER:
    case INVALID_FORMAT_LOWER:
    case INVALID_FORMAT_EMAIL:
    case INVALID_ALPHANUMERIC:
    case INVALID_ALPHA:
    case INVALID_NUMERIC:
    case MAX_LENGTH:
    case MIN_LENGTH:
    case MIN_NUMBER:
    case MAX_NUMBER:
    case INVALID_START_DATE:
    case INVALID_END_DATE:
    case CONTAINS_INVALID_CHARACTERS:
    case INVALID_DECIMAL_PRECISION:
    case INVALID_BEFORE_DURATION:
    case INVALID_AFTER_DURATION:
    case INVALID_DAYS_OF_WEEK:
    case INVALID_START_DATETIME:
    case INVALID_END_DATETIME:
    case INVALID_BEFORE_DATETIME_DURATION:
    case INVALID_AFTER_DATETIME_DURATION:
      return true;
    default:
      return false;
  }
};
export const getErrorMessage = (validatePropertyApiResponse, property, objectTypeId) => {
  const errorCode = getErrorCode(validatePropertyApiResponse, property, objectTypeId);
  if (errorCode === CONFLICTING_CONTACT_EMAIL_VALUE) {
    return {
      code: errorCode,
      message: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        elements: {
          KnowledgeBaseButton
        },
        message: "customerDataProperties.propertyValidationErrorMessages.uniqueEmailConflict_jsx",
        options: {
          useZorse: true,
          url: 'https://knowledge.hubspot.com/articles/kcs_article/contacts/why-cant-i-save-a-new-email-address-for-my-contact'
        }
      })
    };
  }
  if (errorCode === EMAIL_GDPR_DELETED) {
    return {
      code: errorCode,
      message: /*#__PURE__*/_jsxs(_Fragment, {
        children: [validatePropertyApiResponse.message, ' ', /*#__PURE__*/_jsx(KnowledgeBaseButton, {
          useZorse: true,
          url: "https://knowledge.hubspot.com/contacts/how-do-i-perform-a-gdpr-compliant-delete-in-hubspot"
        })]
      })
    };
  }
  if (shouldShowApiErrorMessage(errorCode)) {
    // BE validation error messages are returned pre-translated using Carmen
    // (custom validation errors only; messages with other error codes are
    // NOT translated yet)
    return {
      code: errorCode,
      message: validatePropertyApiResponse.message
    };
  }
  return {
    code: errorCode,
    message: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "customerDataProperties.propertyValidationErrorMessages.unknownError",
      options: {
        propertyName: property.label || property.name
      }
    })
  };
};